import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'

const EmployeeSelfServices = ({ location }) => {
    //const loc = location ? `in ${location.charAt(0).toUpperCase() + location.slice(1)}` : '';

    //const title = `Best Employee Self Services Software ${loc} | ERP Systems | Business Management Solutions - Tejaxo Software`;
    //const metaDesc = `Tejaxo Software is a High Rated Indian Employee Self Services Software ${loc}, providing award-winning Enterprise Resource Planning (ERP) software for Employee Self Services, business management solutions, services and support.`;
    //const metaKey = `Tejaxo Employee Self Services Software ${loc}, Tejaxo Employee Self Services Software`;

    //// Set the document metadata dynamically
    //React.useEffect(() => {
    //    document.title = title;
    //    document.querySelector('meta[name="description"]').setAttribute('content', metaDesc);
    //    document.querySelector('meta[name="keywords"]').setAttribute('content', metaKey);
    //}, [title, metaDesc, metaKey]);

    var aaa = readUrl();
    const [state, setState] = useState(aaa);
    return (
        <MasterPage state={state} >
        <section id="about" className="wow fadeInUp" style={{ backgroundColor: 'white' }}>
            <div className="container">
                <div className="row">
                        <h2 className="mkdf-page-title entry-title">
                            Employee Self Services Software {state.condText}
                    </h2>
                </div>
                <hr />
                <div className="row">
                    <div className="col-sm-5 about-img">
                        <img src="/theme/img/ess2.jpg" alt="Employee Self Services" />
                    </div>
                    <div className="col-sm-7 content">
                        <p>
                            <strong>Employee Self Service</strong> or ESS is a feature provided by <strong>HRMS</strong> that allows the employees to
                            take care of multiple tasks be it related to HR or job that helps the companies to save labor hours and increases
                            efficiency. The employees get access to their employee portal, payroll, and other information using
                            <strong>Employee service portals</strong>.
                        </p>
                    </div>
                </div>
                <br />
                <div className="row">
                    <h2 style={{ fontSize: '23.04px' }}>Tejaxo Employee Self-Service Portal</h2>
                    <p>
                        Tejaxo provides you certain features like <strong>ESS portal</strong>� general activities, ESS portal- <strong>Payroll</strong>, ESS portal-
                        <strong>Attendance</strong>, ESS portal-<strong>Leave</strong>, ESS portal- Help desk, where employees can view their personal information, official documents and letters, company�s policies and forms,
                        <strong>payroll</strong> information, update on tax-related information, leave balance, team leave information, and manage leave transactions. You can even raise your queries to IT, Admin, HR, accounting, or recruitment needs using a dedicated
                        <strong>Employee Service portals</strong> or ESS portal provided by Tejaxo.
                    </p>
                </div>
                <br />
                <div className="row">
                    <ul className="list-group" style={{ width: '1180px' }}>
                        <li className="list-group-item active"><strong>Features of Employee Self-service portal</strong></li>
                        <li className="list-group-item"><strong>Single Sign up dashboard-</strong> Employees have their sign up dashboard to access their information.</li>
                        <li className="list-group-item"><strong>Information Management-</strong> Get easy access to employee information, <strong>attendance</strong>, and leaves.</li>
                        <li className="list-group-item"><strong>Timeline Tracking-</strong> Create and update your tasks and timelines</li>
                        <li className="list-group-item"><strong>Web clock-in or Punch-in</strong>� Reduce the pain to calculate irregularity of the punch-ins through web clock-ins.</li>
                        <li className="list-group-item"><strong>Employee Hierarchy-</strong> It makes it easy for an employee to reach out to the right person in the organization.</li>
                        <li className="list-group-item"><strong>Payroll Regularization-</strong> Declare the investments, tax deductions, and other tax compliances in a go.</li>
                        <li className="list-group-item"><strong>Leave and Attendance-</strong> User-friendly portal to apply for leave or mark the <strong>attendance</strong>.</li>
                    </ul>
                </div>
            </div>
            </section>
        </MasterPage>
    );
};

export default EmployeeSelfServices;
